// extracted by mini-css-extract-plugin
export default {"mainDiv":"LikePopup_mainDiv__tpfuM","container":"LikePopup_container__vLf7I","button":"LikePopup_button__to8ah"};